import { Input, InputRef, SearchProps } from "@p0security/ui";
import classNames from "classnames";
import { forwardRef } from "react";

/** Fixes disgusting prefix styling default for antd inputs */
export const SearchInput = forwardRef<InputRef, SearchProps>(
  ({ className, ...props }, ref) => (
    <Input.Search
      className={classNames(
        "[&_button.ant-input-search-button]:w-8! [&_.ant-input-prefix]:mt-1! [&_.ant-input-prefix]:max-w-full! [&_.ant-input-prefix]:items-baseline! [&_.ant-input]:mb-[unset]!",
        className
      )}
      ref={ref}
      {...props}
    />
  )
);

SearchInput.displayName = "SearchInput";
